import { Dictionary } from "../Utils/Dictionary";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { IpAddress, IpVersion } from "./IpAddress";
import { MacAddress } from "./MacAddress";
import { IfTable, IfEntry } from "../InfoSets/IfTable";
import { Device } from "./Device";

export class LldpEntryKey {
	public TimeMark:number;
	public LocalPortNum: number;
	public Index: number;

	constructor(timeMark: number, localPortNum: number, index: number) {
		this.TimeMark = timeMark;
		this.LocalPortNum = localPortNum;
		this.Index = index;
	}

	public Equals(obj: any): boolean {
		if (!obj)
			return false;

		if (obj == this)
			return true;

		if (!(obj instanceof LldpEntryKey))
			return false;

		var other = <LldpEntryKey> obj;

		return (
			(other != null) &&
			(other.TimeMark == this.TimeMark) &&
			(other.LocalPortNum == this.LocalPortNum) &&
			(other.Index == this.Index)
			);
	}

	public GetHashCode(): number {
		return (ObjUtils.GetHashCode(this.TimeMark) ^ ObjUtils.GetHashCode(this.LocalPortNum) ^ ObjUtils.GetHashCode(this.Index));
	}
}

export class LldpEntry {
	// KEY
	public TimeMark: number;
	public LocalPortNum:number;
	public Index: number;

	// SIGHTING INFO
	public ChassisIdSubtype: number;
	public ChassisId: string;
	public get HasChassisId():boolean {
		return !!this.ChassisId;
	}

	public get ChassisId_IpAddress(): IpAddress {
		var ipAddress: IpAddress = null;

		if (this.HasChassisId) {
			ipAddress = IpAddress.Create(this.ChassisId);
		}

		return ipAddress;
	}

	public get HasChassisId_IpAddress(): boolean {
		return this.ChassisId_IpAddress && this.ChassisId_IpAddress.IsValidDiscoveryAddress;
	}

	public get ChassisId_MacAddress(): MacAddress {
		return this.HasChassisId ? MacAddress.CreateFromString(this.ChassisId) : null;
	}

	public get HasChassisId_MacAddress():boolean	{
		return this.ChassisId_MacAddress && !this.ChassisId_MacAddress.IsNull;
	}

	public PortIdSubtype:number;
	public PortId: string;
	public get HasPortId(): boolean {
		return !!this.PortId;
	}

	public PortDesc: string;
	public get HasPortDesc():boolean {
		return !!this.PortDesc;
	}

	public SysName: string;
	public get HasSysName(): boolean {
		return !!this.SysName;
	}

	public SysDesc: string;
	public get HasSysDesc(): boolean {
		return !!this.SysDesc;
	}

	// REMOTE CACHE
	public RemoteDevice: Device;
	public RemoteIfEntry: IfEntry;

	constructor(timeMark?: number, localPortNum?: number, index?: number) {
		// KEY
		this.TimeMark = timeMark;
		this.LocalPortNum = localPortNum;
		this.Index = index;

		this.Init();
	}

	private Init(): void {
		this.ChassisIdSubtype = -1;
		this.ChassisId = '';

		this.PortIdSubtype = -1;
		this.PortId = '';

		this.PortDesc = '';
		this.SysName = '';
		this.SysDesc = '';
	}

	public ClearRemoteCache(): void {
		this.RemoteDevice = null;
		this.RemoteIfEntry = null;
	}
}

export class LldpTable {
	private _lldpTable: Dictionary<LldpEntryKey, LldpEntry>;

	constructor() {
		this._lldpTable = new Dictionary<LldpEntryKey, LldpEntry>();
		return;
	}

	public Add(timeMark: number, localPortNum: number, index: number): LldpEntry {
		var lldpKey = new LldpEntryKey(timeMark, localPortNum, index);

		var lldpEntry: LldpEntry = this._lldpTable.Item(lldpKey);

		if (lldpEntry) {
			lldpEntry = new LldpEntry(timeMark, localPortNum, index);
			this._lldpTable.Add(lldpKey, lldpEntry);
		}

		return lldpEntry;
	}

	public AddEntry(lldpEntry: LldpEntry): void {
		var lldpKey = new LldpEntryKey(lldpEntry.TimeMark, lldpEntry.LocalPortNum, lldpEntry.Index);
		this._lldpTable.Add(lldpKey, lldpEntry);
	}

	public Clear(): void {
		this._lldpTable.Clear();
	}

	public get Count(): number {
		return this._lldpTable.Count;
	}

	public Remove(lldpEntry: LldpEntry): boolean {
		if (lldpEntry) {
			var cdpKey = new LldpEntryKey(lldpEntry.TimeMark, lldpEntry.LocalPortNum, lldpEntry.Index);
			return this._lldpTable.Remove(cdpKey);
		} else {
			return false
		}
	}

	public ClearRemoteCache(): void {
		this._lldpTable.ForEach((pair) => {
			pair.Value.ClearRemoteCache();
		});
	}

	public ForEach(callbackfn: (value: LldpEntry, index: number, array: LldpEntry[]) => void, thisArg?: any): void {
		this._lldpTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: LldpEntry, index: number, array: LldpEntry[]) => boolean, thisArg?: any): boolean {
		return this._lldpTable.Values().Some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: LldpEntry, index: number, array: LldpEntry[]) => boolean, thisArg?: any): boolean {
		return this._lldpTable.Values().Every(callbackfn, thisArg);
	}
}
